import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { apiClient } from "@/lib/api";

const defaultForm = {
  name: "",
  company: "",
  email: "",
  hiring_needs: "",
  monthly_hiring_volume: "",
};

export const ContactPage = () => {
  const [formData, setFormData] = useState(defaultForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsError(false);
    setResponseMessage("");

    try {
      await apiClient.post("/contact.php", formData);
      setResponseMessage("Thank you! Our AI team will contact you shortly.");
      setFormData(defaultForm);
    } catch (error) {
      setIsError(true);
      setResponseMessage("Unable to submit right now. Please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-7xl px-6 pb-20 pt-16 md:px-10" data-testid="contact-page-wrapper">
      <section className="mb-8" data-testid="contact-page-hero">
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]" data-testid="contact-page-kicker">Book a Demo</p>
        <h1 className="mt-4 text-4xl font-bold md:text-5xl" data-testid="contact-page-heading">Talk with The AI Matters team</h1>
        <p className="mt-5 max-w-3xl text-[#D9E1E8]/80" data-testid="contact-page-subtext">
          Share your hiring goals and we’ll show how AI-powered infrastructure can improve speed and quality.
        </p>
      </section>

      <form onSubmit={handleSubmit} className="glass-panel max-w-3xl space-y-5 rounded-2xl p-6 md:p-8" data-testid="contact-form">
        <div className="grid gap-4 md:grid-cols-2">
          <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Full Name" data-testid="contact-form-name-input" className="border-white/20" />
          <Input name="company" value={formData.company} onChange={handleChange} required placeholder="Company" data-testid="contact-form-company-input" className="border-white/20" />
          <Input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="Work Email" data-testid="contact-form-email-input" className="border-white/20" />
          <Input
            name="monthly_hiring_volume"
            value={formData.monthly_hiring_volume}
            onChange={handleChange}
            required
            placeholder="Monthly Hiring Volume"
            data-testid="contact-form-monthly-hiring-volume-input"
            className="border-white/20 md:col-span-2"
          />
        </div>

        <Textarea
          name="hiring_needs"
          value={formData.hiring_needs}
          onChange={handleChange}
          required
          placeholder="Hiring Needs"
          className="min-h-[120px] border-white/20"
          data-testid="contact-form-hiring-needs-input"
        />

        <Button type="submit" disabled={isSubmitting} className="bg-[#2EC4A6] text-[#071A2C] hover:bg-[#6FE3C1]" data-testid="contact-form-submit-button">
          {isSubmitting ? "Submitting..." : "Book a Demo"}
        </Button>

        {responseMessage ? (
          <p className={`text-sm ${isError ? "text-red-400" : "text-[#6FE3C1]"}`} data-testid="contact-form-response-message">
            {responseMessage}
          </p>
        ) : null}
      </form>
    </div>
  );
};
